<div *ngIf="isShow" class="ddp-label-filter">{{ 'msg.board.general.filter.measure.value.range' | translate }}</div>
<bound-filter *ngIf="isShow" [filter]="targetFilter"></bound-filter>
